import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';

const Profile = () => {
  const { user, tenant } = useAuth();
  const primaryColor = tenant ? tenant.branding.primary_color || '#1B6B3A' : '#1B6B3A';
  const [activeTab, setActiveTab] = useState('profile');
  const isLco = user?.role === 'lco';
  const [profileForm, setProfileForm] = useState({ name: user ? user.name : '', phone: user ? user.phone : '', designation: '', email: user ? user.email : '', contact_person: user ? (user.contact_person||'') : '' });
  const [passwordForm, setPasswordForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const getRoleLabel = (role) => {
    const roles = { superadmin: 'Super Admin', isp_admin: 'ISP Admin', isp_technician: 'ISP Technician', dist_head: 'Distribution Head', dist_l3: 'Distribution L3', dist_l2: 'Distribution L2', dist_l1: 'Distribution L1', subdist_admin: 'Sub Dist Admin', subdist_tech_isp: 'Sub Dist Tech (ISP)', subdist_tech_own: 'Sub Dist Tech (Own)', lco: 'LCO', end_user: 'End User' };
    return roles[role] || role;
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(''); setError('');
    try {
      await authAPI.updateProfile({ name: profileForm.name, phone: profileForm.phone, designation: profileForm.designation, email: profileForm.email, contact_person: profileForm.contact_person });
      setSuccess('Profile updated successfully! Please refresh to see changes.');
    } catch (err) {
      setError(err.response ? err.response.data.message : 'Failed to update profile');
    } finally { setLoading(false); }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setSuccess(''); setError('');
    if (passwordForm.new_password !== passwordForm.confirm_password) {
      return setError('New passwords do not match!');
    }
    if (passwordForm.new_password.length < 6) {
      return setError('Password must be at least 6 characters!');
    }
    setLoading(true);
    try {
      await authAPI.changePassword({ current_password: passwordForm.current_password, new_password: passwordForm.new_password });
      setSuccess('Password changed successfully!');
      setPasswordForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (err) {
      setError(err.response ? err.response.data.message : 'Failed to change password');
    } finally { setLoading(false); }
  };

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: '500' };
  const tabStyle = (tab) => ({ padding: '10px 24px', border: 'none', borderBottom: activeTab === tab ? '3px solid ' + primaryColor : '3px solid transparent', background: 'transparent', color: activeTab === tab ? primaryColor : '#666', fontWeight: activeTab === tab ? '700' : '400', cursor: 'pointer', fontSize: '14px' });

  if (!user) return <div><p>Loading...</p></div>;

  return (
    <div style={{ maxWidth: '700px' }}>
      <h2 style={{ margin: '0 0 20px', color: '#333' }}>My Profile</h2>
      {success && <div style={{ background: '#e8f5e9', color: '#2e7d32', padding: '12px', borderRadius: '6px', marginBottom: '16px', fontWeight: '500' }}>✅ {success}</div>}
      {error && <div style={{ background: '#ffebee', color: '#c62828', padding: '12px', borderRadius: '6px', marginBottom: '16px' }}>{error}</div>}
      <div style={{ background: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', marginBottom: '20px' }}>
        <div style={{ padding: '24px', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div style={{ width: '64px', height: '64px', background: primaryColor, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '24px', fontWeight: '700', flexShrink: 0 }}>
            {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
          </div>
          <div>
            <h3 style={{ margin: '0 0 4px', color: '#333' }}>{user.name}</h3>
            <p style={{ margin: '0 0 4px', color: '#666', fontSize: '14px' }}>{user.email || user.phone}</p>
            <span style={{ background: primaryColor + '20', color: primaryColor, padding: '3px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>{getRoleLabel(user.role)}</span>
          </div>
        </div>
        <div style={{ display: 'flex', borderBottom: '1px solid #f0f0f0', padding: '0 16px' }}>
          <button style={tabStyle('profile')} onClick={() => setActiveTab('profile')}>👤 Profile Info</button>
          <button style={tabStyle('password')} onClick={() => setActiveTab('password')}>🔑 Change Password</button>
          <button style={tabStyle('logininfo')} onClick={() => setActiveTab('logininfo')}>ℹ️ Login Info</button>
        </div>
        <div style={{ padding: '24px' }}>
          {activeTab === 'profile' && (
            <form onSubmit={handleProfileSubmit}>
              {isLco ? (
                <div style={{display:'flex',flexDirection:'column',gap:'14px',marginBottom:'20px'}}>
                  <div>
                    <label style={labelStyle}>Your Name</label>
                    <input type="text" value={profileForm.contact_person} onChange={e=>setProfileForm({...profileForm,contact_person:e.target.value})} style={inputStyle} placeholder="Your full name" />
                  </div>
                  <div>
                    <label style={labelStyle}>Mobile Number</label>
                    <input type="text" value={profileForm.phone} onChange={e=>setProfileForm({...profileForm,phone:e.target.value})} style={inputStyle} placeholder="Your mobile number" />
                  </div>
                  <div>
                    <label style={labelStyle}>Email <span style={{color:'#ef4444',fontSize:'11px'}}>(update if incorrect)</span></label>
                    <input type="email" value={profileForm.email} onChange={e=>setProfileForm({...profileForm,email:e.target.value})} style={inputStyle} placeholder="your@email.com" />
                  </div>
                  <div>
                    <label style={labelStyle}>Network / Business Name</label>
                    <input type="text" value={profileForm.name} style={{...inputStyle,background:'#f8fafc',color:'#94a3b8',cursor:'not-allowed'}} readOnly />
                  </div>
                </div>
              ) : (
                <>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px',marginBottom:'16px'}}>
                  <div><label style={labelStyle}>Full Name *</label><input type="text" value={profileForm.name} onChange={e=>setProfileForm({...profileForm,name:e.target.value})} required style={inputStyle} /></div>
                  <div><label style={labelStyle}>Mobile Number</label><input type="text" value={profileForm.phone} onChange={e=>setProfileForm({...profileForm,phone:e.target.value})} style={inputStyle} placeholder="Your mobile number" /></div>
                </div>
                <div style={{marginBottom:'20px'}}>
                  <label style={labelStyle}>Designation</label>
                  <input type="text" value={profileForm.designation} onChange={e=>setProfileForm({...profileForm,designation:e.target.value})} style={inputStyle} placeholder="e.g. Field Technician" />
                  <label style={{...labelStyle,marginTop:'14px'}}>Email</label>
                  <input type="email" value={profileForm.email} onChange={e=>setProfileForm({...profileForm,email:e.target.value})} style={inputStyle} placeholder="your@email.com" />
                </div>
                </>
              )}
              <button type="submit" disabled={loading} style={{ padding: '10px 24px', background: loading ? '#ccc' : primaryColor, color: 'white', border: 'none', borderRadius: '6px', cursor: loading ? 'not-allowed' : 'pointer', fontWeight: '600' }}>
                {loading ? 'Saving...' : 'Save Profile'}
              </button>
            </form>
          )}
          {activeTab === 'password' && (
            <form onSubmit={handlePasswordSubmit}>
              <div style={{ marginBottom: '16px', padding: '12px', background: '#e3f2fd', borderRadius: '8px' }}>
                <p style={{ margin: '0', fontSize: '13px', color: '#1565c0' }}>
                  💡 <strong>Tip:</strong> Use your mobile number or email to login. Password must be at least 6 characters.
                </p>
              </div>
              <div style={{ marginBottom: '16px' }}>
                <label style={labelStyle}>Current Password *</label>
                <input type="password" placeholder="Enter your current password" value={passwordForm.current_password} onChange={e => setPasswordForm({...passwordForm, current_password: e.target.value})} required style={inputStyle} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
                <div>
                  <label style={labelStyle}>New Password *</label>
                  <input type="password" placeholder="Enter new password" value={passwordForm.new_password} onChange={e => setPasswordForm({...passwordForm, new_password: e.target.value})} required style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Confirm New Password *</label>
                  <input type="password" placeholder="Confirm new password" value={passwordForm.confirm_password} onChange={e => setPasswordForm({...passwordForm, confirm_password: e.target.value})} required style={inputStyle} />
                </div>
              </div>
              <button type="submit" disabled={loading} style={{ padding: '10px 24px', background: loading ? '#ccc' : primaryColor, color: 'white', border: 'none', borderRadius: '6px', cursor: loading ? 'not-allowed' : 'pointer', fontWeight: '600' }}>
                {loading ? 'Changing...' : 'Change Password'}
              </button>
            </form>
          )}
          {activeTab === 'logininfo' && (
            <div>
              {isLco && <div style={{marginBottom:'12px',padding:'16px',background:'#f5f3ff',borderRadius:'8px',border:'1px solid #e9d5ff'}}>
                <p style={{margin:'0 0 4px',fontSize:'12px',color:'#7c3aed',fontWeight:'600'}}>LCO CODE</p>
                <p style={{margin:'0',fontSize:'20px',fontWeight:'800',color:'#7c3aed'}}>{user.username||'-'}</p>
                <p style={{margin:'4px 0 0',fontSize:'12px',color:'#64748b'}}>Use this code to login</p>
              </div>}
              {!isLco && <div style={{ marginBottom: '12px', padding: '16px', background: '#f9f9f9', borderRadius: '8px' }}>
                <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#999', fontWeight: '600' }}>TENANT CODE</p>
                <p style={{ margin: '0', fontSize: '16px', fontWeight: '700', color: primaryColor }}>{tenant ? tenant.code : '-'}</p>
              </div>}
              <div style={{ marginBottom: '12px', padding: '16px', background: '#f9f9f9', borderRadius: '8px' }}>
                <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#999', fontWeight: '600' }}>{isLco ? 'EMAIL / LCO CODE' : 'LOGIN ID (Email or Mobile)'}</p>
                <p style={{ margin: '0', fontSize: '16px', fontWeight: '700', color: '#333' }}>{user.email || user.phone || '-'}</p>
                {isLco && <p style={{margin:'4px 0 0',fontSize:'12px',color:'#64748b'}}>LCO Code: <strong>{user.username||'-'}</strong></p>}
                {!isLco && <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#666' }}>Use this to login to the system</p>}
              </div>
              <div style={{ marginBottom: '12px', padding: '16px', background: '#f9f9f9', borderRadius: '8px' }}>
                <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#999', fontWeight: '600' }}>ROLE</p>
                <p style={{ margin: '0', fontSize: '16px', fontWeight: '700', color: '#333' }}>{getRoleLabel(user.role)}</p>
              </div>
              <div style={{ marginBottom: '12px', padding: '16px', background: '#f9f9f9', borderRadius: '8px' }}>
                <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#999', fontWeight: '600' }}>MOBILE NUMBER</p>
                <p style={{ margin: '0', fontSize: '16px', fontWeight: '700', color: '#333' }}>{user.phone || '-'}</p>
                <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#2e7d32' }}>✅ You can also login with this mobile number</p>
              </div>
              <div style={{ padding: '16px', background: '#e8f5e9', borderRadius: '8px', border: '1px solid #4caf5040' }}>
                <p style={{ margin: '0 0 8px', fontSize: '13px', color: '#2e7d32', fontWeight: '600' }}>📱 How to Login</p>
                <p style={{ margin: '0 0 4px', fontSize: '13px', color: '#333' }}>1. Go to: <strong>desk.pdic.support</strong></p>
                {!isLco && <p style={{ margin: '0 0 4px', fontSize: '13px', color: '#333' }}>2. Tenant Code: <strong>{tenant ? tenant.code : '-'}</strong></p>}
                <p style={{ margin: '0 0 4px', fontSize: '13px', color: '#333' }}>{isLco?'2.':'3.'} Login ID: <strong>{isLco?(user.username||user.email||'-'):(user.email||user.phone||'-')}</strong></p>
                <p style={{ margin: '0', fontSize: '13px', color: '#333' }}>{isLco?'3.':'4.'} Password: <strong>Your password</strong></p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
